import type { ContentCategoryAdmin, ContentCategoryAdminResponse } from '../types';

export function mapContentCategoryAdmin(data: ContentCategoryAdminResponse): ContentCategoryAdmin {
  return {
    id: data.id,
    name: data.name,
    destroyed: data.destroyed,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  };
}
